<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col s12">
        <div class="card">
          <div class="card-title primary white-text">
            <i class="material-icons icon">card_membership</i>
            Subscriptions
            <a @click="$router.push('/subscribe')" class="btn btn-small waves-effect waves-light green right"><i class="material-icons left mr-1">add</i> Add new</a>
          </div>

          <div class="card-content">
            <div class="mb-3">
              Your list of subscriptions are shown below
            </div>

            <div id="data-table">
              <div class="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th
                        v-for="header in headers"
                        :key="header.text"
                        :class="[
                          header.sortable !== false ? 'sortable' : '',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                          header.align === 'right' ? 'right-align' : (header.align === 'center' ? 'center-align' : 'left-align')
                        ]"
                        :width="header.width"
                        @click="header.sortable !== false ? changeSort(header.value) : null"
                      >
                        {{ header.text }}
                        <template v-if="header.sortable !== false">
                          <i v-if="pagination.descending" class="material-icons sortable-arrow">arrow_upward</i>
                          <i v-if="!pagination.descending" class="material-icons sortable-arrow">arrow_downward</i>
                        </template>
                      </th>
                    </tr>
                  </thead>

                  <tbody v-if="loadingList || errorList !== ''">
                    <tr>
                      <td colspan="5">
                        <div v-if="loadingList" class="progress">
                          <div class="indeterminate"></div>
                        </div>
                        <div v-if="errorList !== ''" class="center-align">
                          {{ errorList }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody class="table-body" v-else>
                    <tr
                      v-for="item in subscriptionList"
                      :key="item.id"
                    >
                      <td>
                        <div>
                          <a @click="viewSubscriptionDetails(item)">{{ item.billingName }}</a>
                        </div>
                        <div v-if="item.deliveryChildName !== ''" class="small-text">
                          <i>Deliver to:</i> {{ item.deliveryChildName }}<br>
                          (C/o {{ item.deliveryName }})
                        </div>
                      </td>
                      <td>
                        <div>
                          {{ formatDate(item.added) }}
                        </div>
                        <div class="small-text">
                          {{ formatTime(item.added, true) }}
                        </div>
                      </td>
                      <td>
                        <div v-if="item.status === '1' && item.complete === '0'">
                          <a @click="$router.push('/confirm-details/' + item.uniqueKey)" class="btn btn-small waves-effect waves-light blue-grey">
                            Click to complete
                            <i class="material-icons right icon">chevron_right</i>
                          </a>
                        </div>
                        <div v-else>
                          {{ item.categoryTitle }} ({{ item.planTitle }})
                        </div>
                        <div v-if="item.deliveryChildName !== ''" class="small-text">
                          {{ formatDate(item.planStart) }}
                          to {{ formatDate(item.planEnd) }}
                        </div>
                      </td>
                      <td class="right-align">
                        <div>INR {{ formatAmount(item.grandTotal) }}</div>
                      </td>
                      <td class="center-align">
                        <span
                          class="new badge red white-text"
                          data-badge-caption=""
                          v-if="item.status === '0'"
                        >PENDING</span>
                        <span
                          class="new badge green"
                          data-badge-caption=""
                          v-if="item.status === '1'"
                        >PAID</span>
                        <span
                          class="new badge grey"
                          data-badge-caption=""
                          v-if="item.status === '2'"
                        >CANCELLED</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-if="totalPages > 1" class="center-align mt-4">
              <ul class="pagination">
                <li :class="pagination.page === 1 ? 'disabled' : 'waves-effect'">
                  <a @click="(pagination.page > 1) ? changePage(pagination.page - 1) : null"><i class="material-icons">chevron_left</i></a>
                </li>
                <li v-for="n in totalPages" :key="n" :class="pagination.page === n ? 'active' : 'waves-effect'">
                  <a @click="changePage(n)">{{ n }}</a>
                </li>
                <li :class="pagination.page === totalPages ? 'disabled' : 'waves-effect'">
                  <a @click="(pagination.page < totalPages) ? changePage(pagination.page + 1) : null"><i class="material-icons">chevron_right</i></a>
                </li>
              </ul>
            </div>
          </div>

          <div
            id="editModal"
            class="modal"
            style="width:90%;height:90%;"
          >
            <div class="card mt-0 mb-0">
              <div class="card-title blue-grey lighten-5">
                <i class="material-icons icon">card_membership</i>
                Subscription Details
              </div>

              <div class="card-content">
                <div class="row details-header mb-0">
                  <div class="col s12 m4 mb-3">
                    <div class="card">
                      <div
                        v-if="subscriptionDetails.invoice.status === '0'"
                        class="card-title valign-wrapper red white-text"
                      >
                        <i class="material-icons icon">access_time</i>
                        Payment Pending
                      </div>

                      <div
                        v-if="subscriptionDetails.invoice.status === '1'"
                        class="card-title valign-wrapper green white-text"
                      >
                        <i class="material-icons icon">credit_card</i>
                        Paid
                      </div>

                      <div
                        v-if="subscriptionDetails.invoice.status === '2'"
                        class="card-title valign-wrapper grey"
                      >
                        <i class="material-icons icon">cancel</i>
                        Cancelled
                      </div>

                      <div v-if="loadingSubscriptionDetails" class="card-content valign-wrapper center-align">
                        <LoadingCircle/>
                      </div>

                      <div v-if="!loadingSubscriptionDetails" class="card-content">
                        <div class="row">
                          <div class="col s12 l6">
                            <b>Invoice ID:</b>
                          </div>
                          <div class="col s12 l6">
                            {{ subscriptionDetails.invoice.id }}
                          </div>
                          <div class="clearfix"></div>

                          <div class="col s12 l6">
                            <b>Date/Time:</b>
                          </div>
                          <div class="col s12 l6">
                            {{ formatDate(subscriptionDetails.invoice.added) }}
                            {{ formatTime(subscriptionDetails.invoice.added, true) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col s12 m4 mb-3">
                    <div class="card">
                      <div class="card-title blue-grey lighten-5">
                        <b>Billed to</b>
                      </div>

                      <div v-if="loadingSubscriptionDetails" class="card-content valign-wrapper center-align">
                        <LoadingCircle/>
                      </div>

                      <div v-if="!loadingSubscriptionDetails" class="card-content">
                        <b>{{ subscriptionDetails.user.billingName }}</b>
                        <div v-html="subscriptionDetails.user.billingAddress"></div>
                        <b>Ph:</b> {{ subscriptionDetails.user.billingPhone }}
                      </div>
                    </div>
                  </div>

                  <div class="col s12 m4 mb-3">
                    <div class="card">
                      <div class="card-title blue-grey lighten-5">
                        <b>Deliver to</b>
                      </div>

                      <div v-if="loadingSubscriptionDetails" class="card-content valign-wrapper center-align">
                        <LoadingCircle/>
                      </div>

                      <div v-if="!loadingSubscriptionDetails" class="card-content">
                        <div v-if="subscriptionDetails.user.deliveryChildName !== ''">
                          <b>{{ subscriptionDetails.user.deliveryChildName }}</b><br>
                          C/o {{ subscriptionDetails.user.deliveryName }}
                          <div v-html="subscriptionDetails.user.deliveryAddress"></div>
                          <b>Ph:</b> {{ subscriptionDetails.user.deliveryPhone }}
                        </div>
                        <div v-if="subscriptionDetails.invoice.status === '1' && subscriptionDetails.invoice.complete === '0'">
                          <div v-html="subscriptionDetails.user.deliveryAddress"></div><br>
                          <a @click="$router.push('/confirm-details/' + subscriptionDetails.invoice.uniqueKey)" class="btn btn-small waves-effect waves-light blue-grey">
                            Click to complete
                            <i class="material-icons right icon">chevron_right</i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row details-content mb-0">
                  <div class="col s12 mb-1">
                    <div class="card">
                      <div class="card-title blue-grey lighten-5">
                        <b>Subscription Details</b>
                      </div>

                      <div v-if="loadingSubscriptionDetails" class="card-content valign-wrapper center-align">
                        <LoadingCircle/>
                      </div>

                      <div v-if="!loadingSubscriptionDetails" class="card-content">
                        <div class="table-wrapper">
                          <table>
                            <thead>
                              <tr>
                                <th>
                                  Details
                                </th>
                                <th class="right-align">
                                  Rate
                                </th>
                                <th class="right-align">
                                  Months
                                </th>
                                <th class="right-align">
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <div v-if="subscriptionDetails.user.deliveryChildName !== ''">
                                    {{ subscriptionDetails.invoice.categoryTitle }}
                                    ({{ subscriptionDetails.invoice.planTitle }})<br>
                                    <i class="grey-text">First delivery:</i> {{ formatDate(subscriptionDetails.invoice.planStart) }}<br>
                                    <i class="grey-text">Last delivery:</i> {{ formatDate(subscriptionDetails.invoice.planEnd) }}<br>
                                  </div>
                                  <div v-else>
                                    {{ subscriptionDetails.invoice.planTitle }})
                                  </div>
                                </td>
                                <td class="right-align">
                                  {{ formatAmount(subscriptionDetails.invoice.ratePerMonth) }}
                                </td>
                                <td class="right-align">
                                  {{ subscriptionDetails.invoice.duration }}
                                </td>
                                <td class="right-align">
                                  {{ planTotal }}
                                </td>
                              </tr>

                              <tr>
                                <td colspan="3" class="right-align">
                                  <b>Sub-Total</b>
                                </td>
                                <td class="right-align">
                                  {{ formatAmount(subscriptionDetails.invoice.invoiceTotal) }}
                                </td>
                              </tr>

                              <tr v-if="subscriptionDetails.invoice.discountAmount > 0">
                                <td colspan="3" class="right-align">
                                  Discount: <i>{{ subscriptionDetails.invoice.discountDescription }}</i>
                                </td>
                                <td class="right-align">
                                  -{{ formatAmount(subscriptionDetails.invoice.discountAmount) }}
                                </td>
                              </tr>

                              <tr>
                                <td colspan="3" class="right-align">
                                  Shipping Cost:
                                  <i>INR {{ formatAmount(subscriptionDetails.invoice.shippingPerMonth) }}
                                  x
                                  {{ subscriptionDetails.invoice.duration }}</i>
                                </td>
                                <td class="right-align">
                                  {{ shippingTotal }}
                                </td>
                              </tr>

                              <tr>
                                <td colspan="3" class="right-align">
                                  <b>Grand Total</b>
                                </td>
                                <td class="right-align">
                                  <b>INR {{ formatAmount(subscriptionDetails.invoice.grandTotal) }}</b>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row details-content mb-0">
                  <div class="col s12 m6 mb-3">
                    <div class="card">
                      <div class="card-title blue-grey lighten-5">
                        <b>Order Message</b>
                      </div>

                      <div v-if="loadingSubscriptionDetails" class="card-content valign-wrapper center-align">
                        <LoadingCircle/>
                      </div>

                      <div v-if="!loadingSubscriptionDetails" class="card-content">
                        {{ subscriptionDetails.invoice.orderMessage }}
                      </div>
                    </div>
                  </div>

                  <div class="col s12 m6 mb-3">
                    <div class="card">
                      <div class="card-title blue-grey lighten-5">
                        <b>Shipments</b>
                      </div>

                      <div v-if="loadingSubscriptionDetails" class="card-content valign-wrapper center-align">
                        <LoadingCircle/>
                      </div>

                      <div v-if="!loadingSubscriptionDetails" class="card-content">
                        <div class="table-wrapper">
                          <table>
                            <thead>
                              <tr>
                                <th>
                                  Date
                                </th>
                                <th>
                                  Status
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in subscriptionDetails.shipments"
                                :key="item.shipmentID"
                              >
                                <td>
                                  {{ formatDate(item.shipmentDate) }}
                                </td>
                                <td>
                                  <span
                                    class="new badge grey"
                                    data-badge-caption=""
                                    v-if="item.shipmentStatus === '0'"
                                  >SCHEDULED</span>
                                  <span
                                    class="new badge green"
                                    data-badge-caption=""
                                    v-if="item.shipmentStatus === '1'"
                                  >DISPATCHED</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-action blue-grey lighten-5">
              <a
                class="waves-effect waves-light btn grey lighten-3 black-text right"
                @click="closeDialogEdit"
              >
                Close
              </a>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.details-header .card-title, .details-content .card-title {
  line-height: 26px !important;
  margin-bottom: 0 !important;
  font-size: 20px !important;
  padding: 10px !important;
}
.details-header .card-title i, .details-content .card-title i {
  line-height: 26px !important;
}
.details-header .card-content, .details-content .card-content {
  padding: 15px;
}
@media screen and (min-width: 600px) {
  .details-header {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
  .details-header .card {
    height: 100%;
  }
}
</style>

<script>
import LoadingCircle from '@/components/lib/LoadingCircle'
// Import the API functions
import httpApi from '@/utils/api'

// Date formatting helper
import format from 'date-fns/format'

import numeral from 'numeral'

export default {
  components: {
    LoadingCircle
  },

  data () {
    return {
      // Variable to save subscription list
      subscriptionList: [],

      // Total subscription count, required for pagination
      totalSubscriptions: 0,

      // Loading status for list of items
      loadingList: true,

      // Error message when loading error or no items returned
      errorList: '',

      // Set table defaults
      pagination: {
        page: 1,

        descending: true,

        // Sort by 'added' field
        sortBy: 'added'
      },

      // Table headers
      headers: [
        { text: 'Name', align: 'left', value: 'billingName', sortable: false },
        { text: 'Date', align: 'left', value: 'added' },
        { text: 'Plan', align: 'left', value: 'categoryTitle' },
        { text: 'Total', align: 'right', value: 'grandTotal', sortable: false },
        { text: 'Status', align: 'center', value: 'status', width: '10%', sortable: false }
      ],

      /**
       * Items for dialog form
       */
      // Dialog active?
      editDialog: false,

      // Subscription details loading animation status
      loadingSubscriptionDetails: false,

      // Subscription details setup
      subscriptionDetails: {
        invoice: {
          id: '0',
          added: '',
          categoryTitle: '',
          planTitle: '',
          duration: '',
          planStart: '',
          planEnd: '',
          ratePerMonth: '',
          shippingPerMonth: '',
          invoiceTotal: '',
          shippingAmount: '',
          discountDescription: '',
          discountAmount: '',
          grandTotal: '',
          orderMessage: '',
          status: ''
        },
        shipments: [],
        payment: {
          methodID: '0',
          method: '',
          status: '',
          timeStamp: '',
          amount: '',
          details: ''
        },
        user: {
          billingName: '',
          billingAddress: '',
          billingPhone: '',
          deliveryChildName: '',
          deliveryName: '',
          deliveryAddress: '',
          deliveryPhone: ''
        }
      },

      // Default payment details, so we don't have to check for undefined in HTML
      subscriptionPaymentDefault: {
        methodID: '0',
        method: '',
        status: '',
        timeStamp: '',
        amount: '',
        details: ''
      },

      // Subscription details default setup
      subscriptionDetailsDefault: {
        invoice: {
          id: '0',
          added: '',
          categoryTitle: '',
          planTitle: '',
          duration: '',
          planStart: '',
          planEnd: '',
          ratePerMonth: '',
          shippingPerMonth: '',
          invoiceTotal: '',
          shippingAmount: '',
          discountDescription: '',
          discountAmount: '',
          grandTotal: '',
          orderMessage: '',
          status: ''
        },
        shipments: [],
        payment: {
          methodID: '0',
          method: '',
          status: '',
          timeStamp: '',
          amount: '',
          details: ''
        },
        user: {
          billingName: '',
          billingAddress: '',
          billingPhone: '',
          deliveryChildName: '',
          deliveryName: '',
          deliveryAddress: '',
          deliveryPhone: ''
        }
      }
    }
  },

  mounted () {
    // On load, get data from API and populate table
    this.getFreshData()

    var elems = document.querySelectorAll('.modal')
    // eslint-disable-next-line
    var instances = M.Modal.init(elems)

    // eslint-disable-next-line
    this.dialogEdit = M.Modal.getInstance(document.getElementById('editModal'))
  },

  computed: {
    // Total number of pages
    totalPages () {
      return Math.ceil(this.totalSubscriptions / 10)
    },

    planTotal () {
      let val = this.subscriptionDetails.invoice.ratePerMonth * this.subscriptionDetails.invoice.duration
      return this.formatAmount(val)
    },

    shippingTotal () {
      let val = this.subscriptionDetails.invoice.shippingPerMonth * this.subscriptionDetails.invoice.duration
      return this.formatAmount(val)
    }
  },

  methods: {
    getFreshData () {
      this.getSubscriptionListFromApi()
        .then(data => {
          this.assignFetchedList(data)
        })
        .catch((err) => {
          this.errorList = err.message
        })
    },

    formatAmount (val) {
      return numeral(val).format('0,0.00')
    },

    formatDate (val) {
      return format(val, 'DD MMM YYYY')
    },

    formatTime (val, seconds) {
      if (seconds) {
        return format(val, 'hh:mm:ssa')
      } else {
        return format(val, 'hh:mma')
      }
    },

    /*
    checkPayment (item) {
      let params = '?invoiceID=' + item.id

      // Make the API call
      httpApi.callWithToken({
        url: 'subscription-payment' + params,
        method: 'get'
      })
        .then((resp) => {
          this.subscriptionList[this.subscriptionList.indexOf(item)].status = '1'
        })
    },
    */

    // Change the page
    changePage (pageNo) {
      document.getElementById('data-table').style.height = '125px'
      this.pagination.page = pageNo
      this.getFreshData()
    },

    // Change the column and order of table sorting
    changeSort (sortBy) {
      if (this.pagination.sortBy === sortBy) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = sortBy
        this.pagination.descending = false
      }
      this.getFreshData()
    },

    // Wrapper for the API call
    getSubscriptionListFromApi () {
      // Activate loading animation
      this.loadingList = true

      // Promise a return
      return new Promise((resolve, reject) => {
        // Sort order, which page to get, number of records to get
        const { sortBy, descending, page } = this.pagination

        let params = '?'
        switch (sortBy) {
          case 'added':
            params += 'sortBy=BILL_DATE'
            break

          case 'categoryTitle':
            params += 'sortBy=CATEGORY_TITLE'
            break

          default:
            params += 'sortBy=BILL_DATE'
            break
        }
        params += '&descending=' + ((descending === true) ? 1 : 0)
        params += '&pageNumber=' + page

        // Make the API call
        httpApi.callWithToken({
          url: 'subscription' + params,
          method: 'get'
        })
          .then((resp) => {
            // Deactivate the loading animation
            this.loadingList = false

            // Resolve the promise
            resolve({
              // List of items
              items: resp.data.items,

              // Total number of items returned
              total: resp.data.total
            })
          })
          // If an error occurs
          .catch((err) => {
            // Deactivate the loading animation
            this.loadingList = false

            // Broken promise
            reject(err)
          })
      })
    },

    // API data is assigned to multiple variables
    assignFetchedList (data) {
      this.totalSubscriptions = parseInt(data.total)
      this.subscriptionList = data.items

      this.errorList = (data.total === 0) ? 'No items found' : ''

      // Animate the height after new data loads
      httpApi.animateTableHeight()
    },

    // Open a dialog with subscription details
    viewSubscriptionDetails (item) {
      // Show dialog
      this.dialogEdit.open()

      // Activate loading animation
      this.loadingSubscriptionDetails = true

      // Promise a return
      return new Promise((resolve, reject) => {
        let params = '?invoiceID=' + item.id

        // Make the API call
        httpApi.callWithToken({
          url: 'subscription' + params,
          method: 'get'
        })
          .then((resp) => {
            // Deactivate the loading animation
            this.loadingSubscriptionDetails = false

            this.subscriptionDetails = resp.data
            if (typeof this.subscriptionDetails.payment.status === 'undefined') {
              this.subscriptionDetails.payment = Object.assign({}, this.subscriptionPaymentDefault)
            }

            // Resolve the promise
            resolve()
          })
          // If an error occurs
          .catch((err) => {
            // Deactivate the loading animation
            this.loadingSubscriptionDetails = false

            // Broken promise
            reject(err)
          })
      })
    },

    closeDialogEdit () {
      setTimeout(() => {
        // Set default form fields
        this.subscriptionDetails = Object.assign({}, this.subscriptionDetailsDefault)
      }, 300)
      this.dialogEdit.close()
    }
  }
}
</script>
